export default function BenefitsHeaderLivePreviewBackSvg() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 14.1L8.02682 14.0998L2 8.10023L7.97317 8.10045L14 14.1Z" fill="#214983" />
      <path d="M14 2.09998H8.02691L2 8.10023L7.97317 8.10045L14 2.09998Z" fill="#214983" />
    </svg>
  );
}
